import { transliterateCyrillic } from './transliterateCyrillic'

const slugifyLatin = (value = '') =>
  transliterateCyrillic(String(value))
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_')

export const slugifyTitleForUtm = (value = '') => slugifyLatin(value)

export default slugifyLatin
